import $ from 'jquery';

import 'bootstrap';
import 'bootstrap-datepicker';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.en-GB';
import 'bootstrap-datepicker/js/locales/bootstrap-datepicker.cs';
import 'bootstrap-tagsinput/dist/bootstrap-tagsinput.js'

import moment from 'moment'

window.moment = moment

import '../../../bower_components/nette-forms/src/assets/netteForms.js';
import '../../../bower_components/nette.ajax.js/nette.ajax.js';
import '../../../bower_components/history.js/scripts/bundled-uncompressed/html5/jquery.history.js';
import '../../../bower_components/typeahead.js/dist/typeahead.bundle.js';
import '../../../bower_components/bootstrap-daterangepicker/daterangepicker.js';
import '../../../bower_components/jquery-ui-sortable/jquery-ui-sortable.js';
import '../../../bower_components/dropzone/dist/dropzone.js';
import '../../../bower_components/select2/dist/js/select2.full.js';

import './libs/grido.js'

import './plugins/bootstrap-tagsinput.js'
import './plugins/fileinput.js'
import './plugins/giant.auto-url.js'
import './plugins/giant.ckeditor.js'
import './plugins/giant.cloner.js'
import './plugins/giant.datepicker.js'
import './plugins/giant.dropzone.js'
import './plugins/giant.show-if.js'
import './plugins/giant.sortable.js'
import './plugins/grido.datepicker.js'
import './plugins/grido.daterangepicker.js'
import './plugins/grido.history.js'
import './plugins/grido.nette.ajax.js'
import './plugins/grido.typeahead.js'
import './plugins/substitute.js'
import './plugins/switchery.js'

import './modules/autosubmit.js'
import './modules/batch-operation.js'
import './modules/checkbox-toggle.js'
import './modules/data-confirm.js'
import './modules/description-form.js'
import './modules/event-form.js'
import './modules/filter-autofocus.js'
import './modules/filter.js'
import './modules/nav.js'
import './modules/price-per-day.js'
import './modules/switchery.js'
import './modules/tagsinput.js'


(function() {
    $(".select2").select2();
})();


if ($.nette) {
    $.nette.init();

    $.nette.ext('update', {
        success: function(payload) {
            if (payload.snippets) {
                Object.keys(payload.snippets).forEach(function(elementId) {
                    $('#' + elementId).trigger('change:dom');
                });
            }
        }
    });
}


